<template>
  <div class="row border-bottom g-0 p-1">
    <div :class="['col-8', { 'pe-none': sudah_dinilai }]">
      <div class="row g-0 d-flex justify-content-end mt-1">
        <div class="col-9 d-flex">
          <div style="width: 2rem">{{ title.point }})</div>
          <div class="w-100 pr-5">
            {{ title.text }} <span class="text-danger">*</span>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      <div class="row g-0 d-flex justify-content-end">
        <div class="col-9 d-flex pr-3 border-bottom">
          <label
            :for="`pemenuhan_kewajiban_1_${title.point}`"
            class="d-flex flex-grow-1"
          >
            <div class="d-flex">
              <i class="fa fa-circle"></i>
            </div>
            Sudah dilakukan dan bukti pelaksanaan atau tidak ada aktivitas
            disertai bukti
          </label>
        </div>
        <div class="col-1 border-bottom">
          <div class="form-check ms-2">
            <input
              v-model="form.nilai"
              value="4"
              :id="`pemenuhan_kewajiban_1_${title.point}`"
              v-validate="'required'"
              class="form-check-input"
              type="radio"
              :name="`Pemenuhan Kewajiban ${title.point}`"
            />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="row g-0 d-flex justify-content-end">
        <div class="col-9 d-flex pr-3 border-bottom">
          <label
            :for="`pemenuhan_kewajiban_2_${title.point}`"
            class="d-flex flex-grow-1"
          >
            <div class="d-flex">
              <i class="fa fa-circle"></i>
            </div>
            Sudah dilakukan dan tidak disampaikan bukti pelaksanaan
          </label>
        </div>
        <div class="col-1 border-bottom">
          <div class="form-check ms-2">
            <input
              v-model="form.nilai"
              value="3"
              :id="`pemenuhan_kewajiban_2_${title.point}`"
              v-validate="'required'"
              class="form-check-input"
              type="radio"
              :name="`Pemenuhan Kewajiban ${title.point}`"
            />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="row g-0 d-flex justify-content-end">
        <div class="col-9 d-flex pr-3 border-bottom">
          <label
            :for="`pemenuhan_kewajiban_3_${title.point}`"
            class="d-flex flex-grow-1"
          >
            <div class="d-flex">
              <i class="fa fa-circle"></i>
            </div>
            Belum dilakukan disertai alasan dan dengan rencana pelaksanaan
          </label>
        </div>
        <div class="col-1 border-bottom">
          <div class="form-check ms-2">
            <input
              v-model="form.nilai"
              value="2"
              :id="`pemenuhan_kewajiban_3_${title.point}`"
              v-validate="'required'"
              class="form-check-input"
              type="radio"
              :name="`Pemenuhan Kewajiban ${title.point}`"
            />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="row g-0 d-flex justify-content-end">
        <div class="col-9 d-flex pr-3 border-bottom">
          <label
            :for="`pemenuhan_kewajiban_4_${title.point}`"
            class="d-flex flex-grow-1"
          >
            <div class="d-flex">
              <i class="fa fa-circle"></i>
            </div>
            Belum dilakukan disertai alasan, tanpa rencana pelaksanaan
          </label>
        </div>
        <div class="col-1 border-bottom">
          <div class="form-check ms-2">
            <input
              v-model="form.nilai"
              value="1"
              :id="`pemenuhan_kewajiban_4_${title.point}`"
              v-validate="'required'"
              class="form-check-input"
              type="radio"
              :name="`Pemenuhan Kewajiban ${title.point}`"
            />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="row g-0 d-flex justify-content-end">
        <div class="col-9 d-flex pr-3">
          <label
            :for="`pemenuhan_kewajiban_5_${title.point}`"
            class="d-flex flex-grow-1"
          >
            <div class="d-flex">
              <i class="fa fa-circle"></i>
            </div>
            Belum dilakukan tidak disertai dengan alasan, tanpa rencana
            pelaksanaan atau tidak ada aktivitas tanpa disertai bukti
          </label>
        </div>
        <div class="col-2">
          <div class="form-check ms-2">
            <input
              v-model="form.nilai"
              value="0"
              :id="`pemenuhan_kewajiban_5_${title.point}`"
              v-validate="'required'"
              class="form-check-input"
              type="radio"
              :name="`Pemenuhan Kewajiban ${title.point}`"
            />
          </div>
        </div>
        <div class="col-11">
          <span
            class="text-danger"
            v-if="errors.has(`Pemenuhan Kewajiban ${title.point}`)"
          >
            {{ errors.first(`Pemenuhan Kewajiban ${title.point}`) }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-4">
      <b-form-textarea
        v-model="form.keterangan"
        :id="`pemenuhan_kewajiban_keterangan_${title.point}`"
        :rows="5"
        :disabled="sudah_dinilai"
      ></b-form-textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: ['titletmp', 'formtmp', 'sudah_dinilai'],
  emits: ['form'],
  data() {
    return {
      form: {
        nilai: null,
        keterangan: null,
      },
      title: {
        point: '',
        text: '',
      },
    }
  },
  created() {
    this.getTitle(this.titletmp)
  },
  methods: {
    getTitle(str) {
      let a = str.indexOf(')')
      this.title.point = str.substring(0, a)
      this.title.text = str.substring(a + 1, str.length)
    },

    nextForm() {
      return this.$validator.validateAll()
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit('form', this.form)
      },
    },
    formtmp() {
      this.form = this.formtmp
    },
  },
}
</script>
